export const STEPS = [
  {
    target: "#profileMenuButton",
    content:
      "Click to open profile menu! Here you can find links to all of our main pages.",
    placement: "left",
  },
  {
    target: "#notifications",
    content: "Here you would see your notifications.",
    placement: "left",
  },
  {
    target: "#appLogo",
    content:
      "This can be used to navigate to main page that displays all of the packages",
    placement: "right",
  },
];
